// extracted by mini-css-extract-plugin
export default {"plate":"LicensePlate_plate__QgXWW","sm":"LicensePlate_sm__GI0g7","copyable":"LicensePlate_copyable__beNXz"};